import { AccordionDetails } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ProductDetailsContainer } from "./styled";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { Product } from "../../../shared/models/order/product.model";
import { onProductsChange } from "../../../../services/orders.service";
import { ProductExpanded } from "./blocks/product-expanded";
import { OrderModel } from "../../../shared/models/order/order-item.model";

const Component = ({
    order,
    product,
    products,
    index,
    isReadonly,
    isNewOrder,
    expandedByDefault,
    onExistingOrderProductChange,
    allProductValidationErrors,
    setAllProductValidationErrors,
}: ProductDetailsProps) => {
    const [expanded, setExpanded] = useState(!!expandedByDefault);
    const [validationErrors, setValidationErrors] = useState<{
        [key: string]: any;
    }>({});

    const { weightUnits } = useAppSelector((state) => state.staticDataReducer);

    const dispatch = useAppDispatch();

    useEffect(() => {
        setValidationErrors(
            (allProductValidationErrors && allProductValidationErrors[index]) || {},
        );
    }, [allProductValidationErrors]);

    function onChange(value: any, fieldName: string, product: Product) {
        if (typeof value === "number" && value <= 0) {
            value = undefined;
        }

        const clonedProduct = { ...product };
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        clonedProduct[fieldName] = value;

        if (fieldName === "weight" && !clonedProduct.weightUnit) {
            clonedProduct.weightUnit = weightUnits[0];
        }

        const productsClone = [...products];

        productsClone[index] = clonedProduct;

        if (isNewOrder) {
            onProductsChange(productsClone, dispatch);
        } else {
            onExistingOrderProductChange &&
                onExistingOrderProductChange(productsClone);
        }
    }

    function onRemove() {
        const productsClone = [...products];
        productsClone.splice(index, 1);

        if (isNewOrder) {
            onProductsChange(productsClone, dispatch);
        } else {
            onExistingOrderProductChange &&
                onExistingOrderProductChange(productsClone);
        }
    }

    // function scrollIntoView() {
    //     const productDetails = document.getElementById('declaration-container-' + index);
    //     const mainContentElement = document.getElementById('main-content-container');
    //
    //     if (productDetails && mainContentElement) {
    //         productDetails.scrollIntoView({
    //             behavior: 'smooth',
    //             block: 'start',
    //             inline: 'start'
    //         })
    //     }
    // }

    return (
        <ProductDetailsContainer
            elevation={0}
            defaultExpanded={expandedByDefault}
            onChange={(event, expanded) => setExpanded(expanded)}
            id={"declaration-container-" + index}
        >
            {/*<ProductDetailsSummary>*/}
            {/*    <div style={{display: 'flex', justifyContent: 'space-between'}}>*/}
            {/*        <BarekamButton type={OrderButtons.ADD_PRODUCT} onClick={() => void(0)}>*/}
            {/*            <BarekamIcon variant={IconVariants.arrow} rotation={expanded ? undefined : -90}/>*/}

            {/*            <BarekamText variant={"s"} bold>*/}
            {/*                <Message messageKey={'declaration'} sectionId={MessageSections.ORDERS}/>*/}
            {/*            </BarekamText>*/}
            {/*        </BarekamButton>*/}

            {/*        {products.length > 1*/}
            {/*            ? <BarekamButton type={SimpleButtons.LINK}*/}
            {/*                            onClick={() => onRemove()}>*/}
            {/*                <BarekamIcon variant={OrderIcons.removeProduct}/>*/}
            {/*            </BarekamButton>*/}
            {/*            : ''}*/}
            {/*    </div>*/}

            {/*    {expanded ? <></> : <ProductUnexpanded product={product}/>}*/}
            {/*</ProductDetailsSummary>*/}

            <AccordionDetails>
                <ProductExpanded
                    index={index}
                    product={product}
                    validationErrors={validationErrors}
                    isReadonly={!!isReadonly}
                    order={order}
                    onChange={onChange}
                />
            </AccordionDetails>
        </ProductDetailsContainer>
    );
};

export const ProductDetails = React.memo(Component);

interface ProductDetailsProps {
    key: any;
    index: number;
    order: OrderModel;
    product: Product;
    products: Product[];
    allProductValidationErrors: { [key: string]: { [key: string]: string } };
    setAllProductValidationErrors: (validations: {
        [key: string]: { [key: string]: string };
    }) => void;
    isNewOrder?: boolean;
    isReadonly?: boolean;
    expandedByDefault?: boolean;
    focused?: boolean;

    onExistingOrderProductChange?: (products: Product[]) => void;
}
